<div class="invoice-details-root">
  <div class="header-actions">
    <button id="installation_invoice_details_back" type="button" class="back-button" (click)="goBack()">
      <img src="../../assets/icons/arrow-back.svg" alt="Back icon" />
      <span>{{ 'INSTALLATIONS.INVOICE.BACK_TO_INVOICES' | translate }}</span>
    </button>
    <button id="installation_invoice_details_download" type="button" class="btn btn-outline-success">
      {{ 'COMMON.DOWNLOAD' | translate }}
    </button>
  </div>

  <div class="invoice-card">
    <div class="invoice-card-header">
      <div class="invoice-identity">
        <div class="invoice-id">
          <span id="installation_invoice_details_invoice-id">{{ invoice.invoiceId | hasValue }}</span>
          <div
            id="installation_invoice_details_status"
            *ngIf="invoice.status"
            [ngClass]="{
              'orange-status': invoice.status == 'Pending',
              'green-status': invoice.status == 'Active',
              'blue-status': invoice.status == 'Complete'
            }"
          >
            {{ invoice.status }}
          </div>
        </div>
      </div>
      <div class="invoice-vendor">
        <div class="label">{{ 'INSTALLATIONS.INVOICE.VENDOR' | translate }}</div>
        <div id="installation_invoice_details_vendor" class="value">{{ invoice.vendor | hasValue }}</div>
        <div id="installation_invoice_details_invoice-date" class="label">
          {{ 'INSTALLATIONS.INVOICE.ISSUED_ON' | translate }}: {{ invoice.invoiceDate | date : 'dd/MM/yyyy' | hasValue }}
        </div>
      </div>
    </div>

    <div class="invoice-summary">
      <div class="summary-item">
        <div class="label">{{ 'INSTALLATIONS.INVOICE.TOTAL_INVOICE_AMOUNT' | translate }}</div>
        <div id="installation_invoice_details_total-amount" class="amount">
          {{ invoice.totalAmount != null ? currency + ' ' + (invoice.totalAmount | number : '1.2-2') : '----' }}
        </div>
      </div>
      <div class="summary-item">
        <div class="label">{{ 'INSTALLATIONS.INVOICE.AMOUNT_PAID' | translate }}</div>
        <div id="installation_invoice_details_amount-paid" class="amount green-text">
          {{ invoice.amountPaid != null ? currency + ' ' + (invoice.amountPaid | number : '1.2-2') : '----' }}
        </div>
      </div>
      <div class="summary-item">
        <div class="label">{{ 'INSTALLATIONS.INVOICE.OUTSTANDING_BALANCE' | translate }}</div>
        <div id="installation_invoice_details_balance" class="amount orange-text">
          {{ invoice.balance != null ? currency + ' ' + (invoice.balance | number : '1.2-2') : '----' }}
        </div>
      </div>
      <div class="summary-item">
        <div class="progress-label">
          <span class="label">{{ 'INSTALLATIONS.INVOICE.PAYMENT_PROGRESS' | translate }}</span>
          <span id="installation_invoice_details_payment-progress" class="percentage" [ngClass]="{ 'orange-text': paymentProgress == 0 }">{{ paymentProgress }}%</span>
        </div>
        <app-progress-indicator [maxProgress]="invoice.totalAmount || 0" [currentProgress]="invoice.amountPaid || 0">
        </app-progress-indicator>
      </div>
    </div>

    <div class="invoice-schedule">
      <div class="schedule-title">{{ 'INSTALLATIONS.INVOICE.REPAYMENT_SCHEDULE_DETAILS' | translate }}</div>
      <div class="schedule-items">
        <div class="schedule-item">
          <div class="label">{{ 'INSTALLATIONS.INVOICE.REPAYMENT_PERIOD' | translate }}</div>
          <div id="installation_invoice_details_repayment-period" class="value">
            {{ invoice.repaymentPeriod != null ? invoice.repaymentPeriod + ' ' + ('INSTALLATIONS.INVOICE.MONTHS' | translate) : '----' }}
          </div>
        </div>
        <div class="schedule-item">
          <div class="label">{{ 'INSTALLATIONS.INVOICE.PAID_PERIOD' | translate }}</div>
          <div id="installation_invoice_details_paid-period" class="value">
            {{ invoice.paidPeriod != null ? invoice.paidPeriod + ' ' + ('INSTALLATIONS.INVOICE.MONTHS' | translate) : '----' }}
          </div>
        </div>
        <div class="schedule-item">
          <div class="label">{{ 'INSTALLATIONS.INVOICE.REMAINING_PERIOD' | translate }}</div>
          <div id="installation_invoice_details_remaining-period" class="value">
            {{ invoice.remainingPeriod != null ? invoice.remainingPeriod + ' ' + ('INSTALLATIONS.INVOICE.MONTHS' | translate) : '----' }}
          </div>
        </div>
        <div class="schedule-item">
          <div class="label">{{ 'INSTALLATIONS.INVOICE.MONTHLY_REPAYMENT_AMOUNT' | translate }}</div>
          <div id="installation_invoice_details_monthly-repayment-amount" class="value">
            {{ invoice.monthlyRepaymentAmount != null ? currency + ' ' + (invoice.monthlyRepaymentAmount | number : '1.2-2') : '----' }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="transformers-title">
    {{ 'INSTALLATIONS.INVOICE.INSTALLED_DT_LIST' | translate }} ({{ installedDtCount | number }})
  </div>
  <div id="installation_invoice_details_installed-dt_search" class="search-input">
    <img src="../../assets/icons/search.svg" alt="Search icon" (click)="installedDtSearch()" />
    <input
      type="text"
      [placeholder]="'COMMON.SEARCH' | translate"
      [(ngModel)]="installedDtSearchText"
      (keydown.enter)="installedDtSearch()"
      (ngModelChange)="this.installedDtSearchTextUpdate.next($event)"
    />
  </div>
  <div class="table">
    <div class="table-scroll installed-dt-scroll">
      <table class="table border-bottom">
        <thead class="table-light">
          <tr>
            <th id="installation_invoice_details_table_header_dt-name">{{ 'COMMON.DT_NAME' | translate }}</th>
            <th id="installation_invoice_details_table_header_dt-number">{{ 'COMMON.DT_NUMBER' | translate }}</th>
            <th id="installation_invoice_details_table_header_address" *ngIf="!hasCimDataIntegration">{{ 'COMMON.ADDRESS' | translate }}</th>
            <th id="installation_invoice_details_table_header_dt-type" *ngIf="!hasCimDataIntegration">{{ 'TRANSFORMERS.DT_TYPE' | translate }}</th>
            <th id="installation_invoice_details_table_header_rating">{{ 'TRANSFORMERS.DT_RATING' | translate }}</th>
            <th id="installation_invoice_details_table_header_region">{{ 'COMMON.BU.SINGLE' | translate }}</th>
            <th id="installation_invoice_details_table_header_district">{{ 'COMMON.UT.SINGLE' | translate }}</th>
            <th id="installation_invoice_details_table_header_feeder">{{ 'COMMON.FEEDER' | translate }}</th>
            <th id="installation_invoice_details_table_header_meter-number">{{ 'COMMON.MBC_DETAILS.METER_NO' | translate }}</th>
            <th id="installation_invoice_details_table_header_meter-make">{{ 'INSTALLATIONS.INVOICE.DT_METER_MAKE' | translate }}</th>
            <th id="installation_invoice_details_table_header_meter-price">{{ 'INSTALLATIONS.INVOICE.METER_PRICE' | translate }}</th>
            <th id="installation_invoice_details_table_header_installation-date">{{ 'INSTALLATIONS.INVOICE.INSTALLATION_DATE' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr [id]="'installation_invoice_details_table_row-' + (i + 1)" *ngFor="let installedDt of installedDts; let i = index">
            <td [id]="'installation_invoice_details_table_dt-name-' + (i + 1)" class="green-text">{{ installedDt.dtName | hasValue }}</td>
            <td [id]="'installation_invoice_details_table_dt-number-' + (i + 1)">{{ installedDt.dtNumber | hasValue }}</td>
            <td [id]="'installation_invoice_details_table_address-' + (i + 1)" *ngIf="!hasCimDataIntegration">{{ installedDt.address | hasValue }}</td>
            <td [id]="'installation_invoice_details_table_dt-type-' + (i + 1)" *ngIf="!hasCimDataIntegration">{{ installedDt.dtType | hasValue }}</td>
            <td [id]="'installation_invoice_details_table_rating-' + (i + 1)">{{ installedDt.rating | hasValue }}</td>
            <td [id]="'installation_invoice_details_table_region-' + (i + 1)">{{ installedDt.region | hasValue }}</td>
            <td [id]="'installation_invoice_details_table_district-' + (i + 1)">{{ installedDt.district | hasValue }}</td>
            <td [id]="'installation_invoice_details_table_feeder-' + (i + 1)">{{ installedDt.feederName | hasValue }}</td>
            <td [id]="'installation_invoice_details_table_meter-number-' + (i + 1)">{{ installedDt.meterNumber | hasValue }}</td>
            <td [id]="'installation_invoice_details_table_meter-make-' + (i + 1)">{{ installedDt.meterMake | hasValue }}</td>
            <td [id]="'installation_invoice_details_table_meter-price-' + (i + 1)">
              {{ installedDt.meterPrice != null ? currency + ' ' + (installedDt.meterPrice | number : '1.2-2') : '----' }}
            </td>
            <td [id]="'installation_invoice_details_table_installation-date-' + (i + 1)">{{ installedDt.installationDate | date : 'dd/MM/yyyy' | hasValue }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <app-paging
        *ngIf="installedDtCount > 0"
        [pageSize]="installedDtPageSize"
        [count]="installedDtCount"
        [currentPage]="installedDtCurrentPage"
        [useDirect]="true"
        (pageChange)="installedDtPageChange($event)"
      ></app-paging>
    </div>
  </div>
</div>
